import HelpCircle from '@mdi/svg/svg/help-circle.svg?react';
import { MDIIcon, ProgressBar } from '@solinkcorp/solink-components';
import { Component } from 'react';
import './EventVideos.sass';

export default class EventVideos extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    videos: [],
  };

  render() {
    const { videos } = this.props;

    if (!videos || videos.length === 0) {
      return null;
    }

    return (
      <div className="cloud-video-info">
        {videos &&
          videos.map((video, idx) => {
            return (
              <div key={`event-video-${idx}`}>
                <div className="video">
                  {video.cameraId}
                  <span onMouseOver={this._showVideoInfo.bind(this, video)}>
                    <MDIIcon icon={HelpCircle} />
                  </span>
                </div>
                {video.status === 'inProgress' && (
                  <ProgressBar
                    color="orange"
                    mode="determinate"
                    style={{ background: '#eee' }}
                    value={video.progress * 10}
                  />
                )}
                {video.status === 'inProgress' && (
                  <div className="progress-number">
                    <div>{`${video.size.toFixed(0)}MB / ${video.length.toFixed(0)} min`}</div>
                    {`${(video.progress * 10).toFixed(0)}%`}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  }

  _showVideoInfo() {}
}
